import React from 'react'
import { Link } from 'react-router-dom'

export default function EmptyOrderPage({text, url, action, title, search, all,}) {
    return (
        <div className="py-6 pl-12 pr-[18px] main-screen" onScroll={(e) => e.preventDefault()}>
            <div className="flex justify-between">
                {/* <h5 className="text-xs4 font-normal text-[#555259]">{title}</h5> */}
            </div>
            <div className="flex flex-col items-center justify-center " style={{height: 'calc(100vh - 222px)'}}>
                <img src="/images/Group8022.svg" alt="" />
                <p>
                    It seems there are
                    {' '}
                    <span className="text-[#ED1C24] mt-2 cursor-pointer">
                        {' '}
                        {text}
                    </span>
                    {' '}
                    {search === '' ? 'created yet!' : <>{all || 'under the searched term.'}</>}
                </p>
                {search === ''
                && (
                    <Link to={`${url}`}>
                        <button
                            style={{ minWidth: '300px' }}
                            className="rounded-lg bg-[#555259] text-lg font-semibold text-[#FFFFFF] W-[300px] h-[53px] mt-8"
                        >
                            {action}
                        </button>
                    </Link>
                )}
            </div>
        </div>
    )
}
